import { loading } from 'State/actions';
import * as types from './types';
import _ from 'lodash';
import { SITESETUP_GRID_LOADING } from '../settings/types';
import { SITESETUP_SET_ASSIGN_LOADING } from '../assignUsers/types';
import { NotificationMessage } from 'Components/messages/ApiResultMessage';
import {
  ChargeTypeMode,
  RestrictionType,
} from '../../helpers/SiteSetupConstants';

export const getSiteSetup = (filter) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(SITESETUP_GRID_LOADING, true));

    try {
      const siteResponse = await MPWWebApi.getGeneric(
        'Sitemaster?allSites=true'
      );

      dispatch({
        type: types.SITESETUP_GET,
        payload: siteResponse,
      });

      dispatch(setFilteredData(filter));

      const siteGroupResponse = await MPWWebApi.getGeneric('SiteGroup');

      dispatch({
        type: types.SITESETUP_GET_SITEGROUPS,
        payload: siteGroupResponse,
      });

      dispatch({
        type: types.SITESETUP_MAP_COLUMNS,
      });
    } catch (err) {
      //not doing anything currently
    }

    dispatch(loading(SITESETUP_GRID_LOADING, false));
  };
};

export const postDeleteSite = (Id) => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.SITESETUP_BEGIN_SUBMIT,
    });
    return new Promise((resolve, reject) => {
      MPWWebApi.postGenericDelete('Sitemaster', Id)
        .then((response) => {
          dispatch({
            type: types.SITESETUP_POST,
            payload: response,
          });

          dispatch({
            type: types.SITESETUP_END_SUBMIT,
          });
          resolve();
        })
        .catch((err) => {
          dispatch({
            type: types.SITESETUP_HAD_ERROR,
            payload: err.response.data.Errors,
          });
          reject(err.response.data.Errors);
        });
    });
  };
};

export const postSitemaster = (values) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch({
      type: types.SITESETUP_BEGIN_SUBMIT,
    });
    try {
      //Set to null to prevent the string 'MBE Not Enabled'
      //flagging as invalid when converting to DateTime
      //on the API; this field is not saved to the SiteMaster
      //table anyway as it is calculated when saving a
      //School Calendar
      values.MealExpirationDT = null;

      const postResponse = await MPWWebApi.postGenericInsertUpdate(
        'Sitemaster',
        values
      );

      if (values.WareHousesAndKitchens) {
        const SelectedSiteWarehouse = [];
        _.each(values.WareHousesAndKitchens, (item) => {
          if (item.Id) {
            SelectedSiteWarehouse.push({
              Id: item.Id,
              Description: item.text,
            });
          } else {
            SelectedSiteWarehouse.push({
              Id: 0,
              Description: item.text,
            });
          }
        });
        const requestBody = {
          SiteId: values.Id,
          OrderPreferenceId: values.OrderPreferenceId,
          SiteMasterType: values.SiteMasterTypeId,
          SelectedSiteWarehouse: SelectedSiteWarehouse,
        };

        await MPWWebApi.postGenericInsertUpdate(
          'InvSiteWarehouse/SaveSiteWarehouse',
          requestBody
        );
      }

      dispatch({
        type: types.SITESETUP_POST,
        payload: postResponse,
      });

      const {
        SiteSetupState: { chargeLimit },
      } = getState();
      const saveChargeData = {
        SiteId: values.Id,
        ChargeByStatusMode:
          chargeLimit.restrictionType === RestrictionType.Site
            ? ChargeTypeMode.NumberOfMeals
            : ChargeTypeMode.NoRestrictions,
        ChargeLimits: chargeLimit.data,
      };

      await MPWWebApi.postGenericInsertUpdate(
        `poschargebystatus`,
        saveChargeData
      );

      dispatch({
        type: types.SITESETUP_END_SUBMIT,
      });

      return Promise.resolve();
    } catch (err) {
      dispatch({
        type: types.SITESETUP_HAD_ERROR,
        payload: err.response.data.Errors,
      });
      return Promise.reject(err.response.data.Errors);
    }
  };
};

export const postUsersHaveAccess = (data, showLicensed) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(SITESETUP_SET_ASSIGN_LOADING, true));
    try {
      const assignResponse = await MPWWebApi.postGenericInsertUpdate(
        'UserSiteByProd/AssignUsersToSitesWithAccessFunction',
        data
      );
      dispatch(getSiteSetup(showLicensed));
      NotificationMessage(
        assignResponse,
        undefined,
        undefined,
        'The site has been updated with the selected user(s).'
      );
    } catch (ex) {
      NotificationMessage(ex.response);
    }

    dispatch(loading(SITESETUP_SET_ASSIGN_LOADING, false));
  };
};

export const setFilteredData = (payload) => {
  return {
    type: types.SITESETUP_SET_FILTERED_DATA,
    payload,
  };
};

export const clearErrors = () => {
  return {
    type: types.SITESETUP_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/page/actions.js